exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.btn .fa[data-v-5245836f] {\n    margin-right: 0;\n}\n", ""]);

